import React, { useEffect, useState } from "react";
import axios from "axios";
import "./AssetCustomer.css";
import "./menu3.css";
import { useNavigate } from "react-router-dom";
import Headers from "../Home/Header";
import Footer from "../Home/Footer";
import TicketSidebar from "../components/TicketSidebar";

axios.defaults.withCredentials = true;

const ITEMS_PER_PAGE = 20;

const AssetListCustomer = () => {
  const navigate = useNavigate();
  const [assets, setAssets] = useState([]);
  const [filteredAssets, setFilteredAssets] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetchAssets();
  }, []);

  useEffect(() => {
    const keyword = search.toLowerCase().trim();

    if (!keyword) {
      setFilteredAssets(assets);
      setCurrentPage(1);
      return;
    }

    const filtered = assets.filter((item) =>
      String(item.prd_serial || "")
        .toLowerCase()
        .includes(keyword),
    );

    setFilteredAssets(filtered);
    setCurrentPage(1);
  }, [search, assets]);

  const fetchAssets = async () => {
    try {
      const res = await axios.get(
        "/project-customers/my-assets",
        {
          withCredentials: true,
        },
      );
      const rows = Array.isArray(res.data) ? res.data : [];
      setAssets(rows);
      setFilteredAssets(rows);
    } catch (err) {
      console.error("fetchAssets error:", err);
      setAssets([]);
      setFilteredAssets([]);
    }
  };

  const totalPages = Math.ceil(filteredAssets.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const paginatedAssets = filteredAssets.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE,
  );

  return (
    <>
      <Headers />
      <div className="asset-page">
        <TicketSidebar active="/customer/assets" />

        <div className="asset-main">
          <div className="asset-card">
            <div className="asset-topbar">
              <div className="asset-customer-title">
                {assets?.[0]?.customer_name?.trim()
                  ? `Customer : ${assets[0].customer_name}`
                  : ""}{" "}
              </div>

              <div className="asset-search-wrap">
                <input
                  type="text"
                  className="asset-search-input"
                  placeholder="Search serial..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>

            <div className="asset-table-wrap">
              <table className="asset-table">
                <thead>
                  <tr>
                    <th>Serial Number</th>
                    <th>Product</th>
                    <th>Company</th>
                    <th>Service Expiry Date</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedAssets.length > 0 ? (
                    paginatedAssets.map((item) => (
                      <tr key={item.id}>
                        <td className="serial-link">
                          <a
                            href={`/customer/assets/${item.id}`}
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(`/customer/assets/${item.id}`, {
                                state: { asset: item },
                              });
                            }}
                            className="asset-row-link"
                          >
                            {item.prd_serial || "-"}
                          </a>
                        </td>
                        <td>{item.prd_label || "-"}</td>
                        <td>{item.cus_name || "-"}</td>
                        <td>
                          <div>{item.expiry || "-"}</div>

                          {item.is_near_expiry === 1 && (
                            <div className="expiry-warning">
                              (บริการใกล้หมดอายุ)
                            </div>
                          )}
                        </td> 
                        <td>
                          <span
                            className={
                              item.ma_status === "Active"
                                ? "status-badge active"
                                : "status-badge expired"
                            }
                          >
                            {item.ma_status || "-"}
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="empty-row">
                        ไม่พบข้อมูล
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {totalPages > 1 && (
              <div className="ticket-pagination">
                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  disabled={currentPage === 1}
                >
                  Previous
                </button>

                {Array.from({ length: totalPages }, (_, index) => {
                  const page = index + 1;
                  return (
                    <button
                      key={page}
                      onClick={() => setCurrentPage(page)}
                      className={currentPage === page ? "active-page" : ""}
                    >
                      {page}
                    </button>
                  );
                })}

                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AssetListCustomer;
